import 'babel-polyfill';
import 'whatwg-fetch';

import Vue from 'vue';
import router from './routes/router';
import cookieUtil from './util/cookieUtil';
import appView from './views/appView.vue';
import Element from '@jd/element-ui';
import enLocale from '@jd/element-ui/lib/locale/lang/en';
import cnLocale from '@jd/element-ui/lib/locale/lang/zh-CN';
import '@jd/element-ui/lib/theme-default/index.css';
import Fetch from './api/Fetch';
//国际化组件
import VueI18n from 'vue-i18n';

Vue.use(Element, {
    i18n: (key, value) => i18n.t(key, value)
});
Vue.use(VueI18n);
Vue.use(Fetch);

const i18n = new VueI18n({
    locale: cookieUtil.getCookie('jdcloud_sitelang', 'cn'),
    messages: {
        'cn': Object.assign(require('./common/lang/cn'), cnLocale),
        'en': Object.assign(require('./common/lang/en'), enLocale)
    }
});

const app = new Vue({
    router,
    i18n,
    ...appView
});

app.$mount('#app');

Vue.prototype.$eventbus = new Vue();
